import ClassSelector from './class-selector.vue';

export default {
  install(application) {
    application.component('yx-class-selector', ClassSelector);
  },
};
